import branding from './brandingData.json';

/**
 * User-facing product name — change [`brandingData.json`](./brandingData.json) only.
 *
 * Keep native home-screen label in sync:
 * `packages/budget/app.json` → `displayName` must equal `appName`.
 *
 * Note: JSON must not share a basename with this module (`branding.json` + `branding.ts`
 * causes Metro to resolve the JSON and break named exports like `signInHeadline`).
 */
export const APP_NAME: string = branding.appName;

export const SUPPORT_EMAIL = 'support@moneylensai.ca';
export const PRIVACY_EMAIL = 'privacy@moneylensai.ca';

export function signInHeadline(): string {
  return `Sign in to ${APP_NAME}`;
}
